// Which way a dropdown should open from its trigger, and how tall it can be.
//
// The language selector always opened downward. In the phone menu its chip is
// pinned to the bottom of the sheet, so the list landed below the screen: on a
// 375x812 phone it started at 767px and not one language was visible.

const GAP = 5; // px between trigger and list, matching the CSS offset
const EDGE = 8; // px kept clear of the viewport edge
const MIN_HEIGHT = 160; // search box plus a few rows; below this it is unusable

/**
 * Open downward when the preferred height fits below the trigger; otherwise
 * open toward whichever side has more room, shrunk to fit that side.
 */
export function dropdownPlacement(
  triggerTop: number,
  triggerBottom: number,
  viewportHeight: number,
  preferredHeight: number,
): { openUp: boolean; height: number } {
  const below = viewportHeight - triggerBottom - GAP - EDGE;
  const above = triggerTop - GAP - EDGE;
  const openUp = below < preferredHeight && above > below;
  const room = openUp ? above : below;
  return {
    openUp,
    height: Math.max(MIN_HEIGHT, Math.min(preferredHeight, room)),
  };
}
